import IconCalendar from './assets/icon_calendar.svg';
import IconSchedule from './assets/icon_schedule.svg';
import IconScheduleWarning from './assets/icon_schedule_warning.svg';

export const OPTIONS = t => [
  {
    icon: IconCalendar,
    title: t('options.option_1_title'),
    description: t('options.option_1_desc'),
    fee: '0.85%',
  },
  {
    icon: IconSchedule,
    title: t('options.option_2_title'),
    description: t('options.option_2_desc'),
    fee: '1.5%',
  },
  {
    icon: IconScheduleWarning,
    title: t('options.option_3_title'),
    description: t('options.option_3_desc'),
    fee: '3%',
  },
];

export const BENEFITS = t => [
  {
    title: t('benefits.ben_1_title'),
    description: t('benefits.ben_1_desc'),
  },
  {
    title: t('benefits.ben_2_title'),
    description: t('benefits.ben_2_desc'),
  },
  {
    title: t('benefits.ben_3_title'),
    description: t('benefits.ben_3_desc'),
  },
];
